module.exports = __webpack_public_path__ + "fonts/down-arrow.c723acec7705c81ee661.svg";